import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import * as styles from './SettingsSubmitConfirmation.module.scss';
import SVGIcon from '../components/SVGIcon';
import checkIcon from '../icons/non-prefilled/16x16/check.svg';

export const useSubmitWithSaved = <A extends unknown[], R>(
  submit: (...args: A) => Promise<R>,
) => {
  const [isSaved, setIsSaved] = useState(false);
  const handleSubmit = async (...args: A) => {
    setIsSaved(false);

    const response = await submit(...args);
    setIsSaved(true);
    return response;
  };

  return { saved: isSaved, handleSubmit };
};

const SettingsSubmitConfirmation = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(false);
    });

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <span
      className={classNames(styles.confirmation, {
        [styles.fadeOut]: !isVisible,
      })}
    >
      <SVGIcon inline>{checkIcon}</SVGIcon> Saved
    </span>
  );
};

export default SettingsSubmitConfirmation;
